module.exports = __webpack_public_path__ + "static/media/mobile.5dd385ab.svg";